import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
            了解黄桃视频的故事与初心
          </p>
          <div className="space-y-5 md:space-y-6">
            {aboutData.paragraphs.map((p, idx) => (
              <p
                key={idx}
                className="text-sm md:text-base text-foreground-600 leading-relaxed"
              >
                {p}
              </p>
            ))}
          </div>
          <div className="mt-8 md:mt-10 flex justify-center">
            <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-primary-50 text-primary-700">
              <i className="ri-heart-line text-lg"></i>
              <span className="text-sm font-medium">好片不断档，精彩不等待</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}